import styles from "./index.module.scss";
import { NextPage } from "next";
import StockAnalyst from "@/components/stock-analysts/StockAnalysts";
import { Stock } from "@/models/stock";
import Head from "next/head";
import { buildStockOgImage } from "@/lib/stock-og";
import { useSetAtom } from "jotai";
import { stockTradingItemIdState } from "@/lib/store";
import { useEffect } from "react";
import { stockPageGetServerSideProps } from "@/lib/stock-page-ssr";
import { stockDescriptions, stockTitle } from "@/lib/stock-seo";
import { stockCanonicalUrl } from "@/lib/stock-url";

const StockAnalystsPage: NextPage<{ stock: Stock }> = ({ stock }) => {
    const setStockTradingItemId = useSetAtom(stockTradingItemIdState);

    useEffect(() => {
        stock ? setStockTradingItemId(stock.tradingitem_id) : setStockTradingItemId(null);
    }, [stock]);
    return (
        <>
            {stock &&
                (() => {
                    const { ogImageUrl, cardTitle } = buildStockOgImage(stock, "Analysts");
                    return (
                        <Head>
                            <title>{stockTitle(stock, "analysts")}</title>
                            <link rel="canonical" href={stockCanonicalUrl(stock, "analysts")} />
                            <meta name="keywords" content={`${stock.name}, ${stock.exchangesymbol}:${stock.ticker}, Analysts, Estimates, EPS, Target Price`} />
                            <meta name="description" content={stockDescriptions.analysts(stock)} />
                            <meta name="twitter:card" content="summary_large_image" />
                            <meta name="twitter:title" content={stockTitle(stock, "analysts")} />
                            <meta name="twitter:description" content={stockDescriptions.analysts(stock)} />
                            <meta name="twitter:url" content={stockCanonicalUrl(stock, "analysts")} />
                            <meta name="twitter:image" content={ogImageUrl} />
                            <meta name="twitter:image:alt" content={cardTitle} />
                            <meta property="og:title" content={stockTitle(stock, "analysts")} />
                            <meta property="og:description" content={stockDescriptions.analysts(stock)} />
                            <meta property="og:url" content={stockCanonicalUrl(stock, "analysts")} />
                            <meta property="og:image" content={ogImageUrl} key="og:image" />
                            <meta property="og:image:width" content="1200" />
                            <meta property="og:image:height" content="630" />
                            <meta property="og:image:alt" content={cardTitle} />
                        </Head>
                    );
                })()}
            <div className={styles.StockAnalystsPage}>{stock ? <StockAnalyst stock={stock} /> : <h1>Stock not found.</h1>}</div>
        </>
    );
};

export const getServerSideProps = stockPageGetServerSideProps({ tab: "analysts", allowedTypes: [1] });

export default StockAnalystsPage;
